module.exports = __webpack_public_path__ + "img/description.043eee62.svg";